'use strict';

angular.module('licensure.services')
    .factory('EXAlertTypes', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/EXAlertTypes', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },


            getalerttype: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXAlertTypes/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },
            save: function (alertype) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/EXAlertTypes/";
                if (!isUndefined(alertype.id)) {
                    method = "PUT";
                    url += alertype.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        exam_alert_type: alertype,
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/EXAlertTypes/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
    ;